<template>
  <div class="index-page">repayment</div>
</template>
<script>
// import middleKey from "../components/middleKey.vue"; //中间件
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {}
};
</script>


// WEBPACK FOOTER //
// src/components/page/repayment.vue